import React from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import Navbar from './components/Navbar/Navbar';
import './App.css';
import Home from './pages/Home';
import Partnerships from './pages/Partnership';
import Artists from './pages/Artists';
import ConcretePage from './pages/Concrete';
import JerryGPage from './pages/JerryG';
import doknowsworldPage from './pages/Doknowsworld';
import LaChonaPage from './pages/ChonaE';
import Shows from './pages/Shows';
import Contact from './pages/Contact';
import AboutPage from './pages/About';

function App() {
  return (
    <Router>
      <Navbar />
      <Switch>
        <Route path='/' exact component={Home} />
        <Route path='/Partnerships' exact component={Partnerships} />
        <Route path='/Comidians' exact component={Artists} />
        <Route path='/Concrete' exact component={ConcretePage} />
        <Route path='/JerryG' exact component={JerryGPage} />
        <Route path='/Doknowsworld' exact component={doknowsworldPage} />
        <Route path='/ChonaE' exact component={LaChonaPage} />
        <Route path='/shows' exact component={Shows} />
        <Route path='/contact' exact component={Contact} />
        <Route path='/about' exact component={AboutPage} />
      </Switch>
    </Router>
  );
}

export default App;